import { Link } from 'react-router-dom';

import CompanyLogo from '~/components/CompanyLogo';
import Avatar from '~/components/PersonAvatar';
import paths from '~/lib/paths';

import styles from './Header.style';

class Header extends React.Component {
  render() {
    const { classes, person } = this.props;

    const logo = (
      <CompanyLogo
        className={classes.companyLogoLink}
        src={person.company.logo}
        domain={person.company.domain}
        size={48}
      />
    );

    return (
      <div className={classes.root}>
        <div className={classes.profile}>
          <Avatar src={person.avatar} size={47} />

          <div className={classes.details}>
            <h2 className={classes.name}>{person.name}</h2>
            <h3 className={classes.email}>{person.email}</h3>
          </div>

          {person.company_id ? (
            <Link
              to={paths.company(person.company_id)}
              className={classes.companyLogoLink}>
              {logo}
            </Link>
          ) : (
            logo
          )}
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  person: PropTypes.shape({
    avatar: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
